import { AnchorEntity } from "../anchor";
import { AvatarActionInstance, AvatarComponent } from "../avatar";
import { AnimationActionInstance } from "../animation/animation-action";
import { InputActionDetail } from "../input/common";
import { SlotEntity } from "../slot";
import { AvatarInteractionTarget } from "./interaction-target";


export class AvatarGrabAction implements AvatarActionInstance
{
	target : AvatarInteractionTarget;
	input? : InputActionDetail;
	animation? : AnimationActionInstance;
	longActionTimeout : number = NaN;

	constructor(avatar : AvatarComponent, input : InputActionDetail, target : AvatarInteractionTarget, action : string )
	{
		this.target = target;
		const scene = avatar.el.sceneEl!;
		if(scene.is("vr-mode"))
		{
			this.input = input;
			if(!target.slot!.components.slot.data.anchor) //Nothing in hand : grab target item
			{
				this.grab(avatar);
			}
		}
		else if( !scene.is("ui-mode") )
		{
			target.locked = true; //Lock until animation ends.
			const animationTarget = target.slotItem ? 
				target.currentTarget :  //Put/Drop
				(target.currentAnchor || target.currentTarget);
			this.animation = new AnimationActionInstance(avatar, input, action, target.slot!, animationTarget);
		}
		else
			this.grab(avatar);
	}


	grab(avatar : AvatarComponent)
	{
		var anchorEl = this.target.currentTarget as AnchorEntity;
		var slotEl : SlotEntity | null = this.target.slot!;
		var alignSlotEl : SlotEntity | null = null;

		const currentSlotItem = slotEl.components.slot.data.item;
		if(currentSlotItem) //Something in slot : attach to target slot
		{
			anchorEl = this.target.currentAnchor!; // || slotEl.components.slot.data.anchor!;
			slotEl = this.target.currentSlot!; // || this.target.currentTarget as SlotEntity;

			//(anchorEl,slotEl) might not be a valid "put" couple :
			const anchorC = anchorEl && anchorEl.components.anchor;

			if(anchorC && slotEl && anchorC.data.enabled &&anchorC.fits(slotEl))
			{
				if(! anchorC.data.attach ) //Anchor fits but doesn't attach : remove from this.target.slot! and ALIGN to slotEl
				{
					alignSlotEl = slotEl;
					slotEl = null;
				}
			}
			else
			{
				//In that case, the action is "drop"/"store"
				anchorEl = this.target.slot!.components.slot.data.anchor!;
				slotEl = null;
			}
		}
		else //Nothing in slot : take
		{
			const currentAnchorSlot = anchorEl && anchorEl.anchor_slot && anchorEl.anchor_slot.components.slot;
			if(currentAnchorSlot && currentAnchorSlot.data.locked)
				return; //Can't take something in a locked slot
		}

		if(!anchorEl)
		{
			//Nothing to do anymore
			//Probably because the object we grabbed was removed for any reason
			return;
		}


		if(currentSlotItem)
		{
			// Make sure the slot holding the item is unlocked to perform the detach process
			this.target.slot!.setAttribute("slot", { locked : false } );
		}

		
		if(slotEl) //Take or put
		{
			const event = new CustomEvent("attach-to-slot", { detail : slotEl, bubbles : true });
			(event as any).input = this.input;
			anchorEl.dispatchEvent(event);
		}
		else //Release : Drop or put back
		{
			if(currentSlotItem && this.target.currentTarget)
			{
				//Release (in vr) while touching an inventory-item that accepts currentSlotItem : link to inventory-item
				const invItem = this.target.currentTarget.components["inventory-item"]?.data;
				if(invItem?.accept?.length)
					for(let condition of invItem.accept)
						if(currentSlotItem.matches(condition))
						{
							this.target.currentTarget.setAttribute("inventory-item", { item : currentSlotItem });
							break;
						}
			}
			
			const event = new CustomEvent("detach-from-slot", { detail : this.target.slot!, bubbles : true });
			(event as any).input = this.input;
			anchorEl.dispatchEvent(event);
			if( alignSlotEl )
				anchorEl.dispatchEvent(new CustomEvent("attach-to-slot", { detail : alignSlotEl, bubbles : true} ));
		}

		this.input && this.input.feedback(1.0);
	}
	
	tick(avatar : AvatarComponent, t : number, dt : number) : boolean
	{
		if(!avatar.groundContacts.length) return false;
		if(this.animation && !this.animation.tick(avatar, t, dt)) //Yay, finished the anim
		{
			//unlock detection target
			this.target.locked = false;
			if(this.animation.completed)
				this.grab(avatar);
			return false; //Done!
		}
		
		if(this.input && (this.input.amount <= 0)) //Input ended : release item unless it was a short click
		{
			if( Date.now() < this.longActionTimeout ) //Short grab : keep in slot
				return false;

			this.grab(avatar);
			return false;
		}



		return Boolean(this.animation || this.input);
	}
	destroy(avatar : AvatarComponent) : void 
	{
		this.animation && this.animation.destroy(avatar);
	}
}

